import { plural } from '~/lib/upfront';
import type { UnitAttributes } from '~/types';

export const useUnitStore = defineStore('unit', () => {
    const units = ref<UnitAttributes[]>([]);

    const relativeUnits = computed(() => {
        return units.value.filter(unit => unit.isRelative === true);
    });
    const absoluteUnits = computed(() => {
        return units.value.filter(unit => unit.isRelative === false);
    });

    const getDisplayName = (unit: UnitAttributes | UnitAttributes['id'], amount?: number): string => {
        unit = typeof unit === 'number' ? units.value.find(u => u.id === unit)! : unit;
        const name = unit.name ?? unit.abbreviation;

        if (unit.isRelative === true || !amount) {
            return name;
        }

        return amount > 1 ? plural(name) : name;
    };

    return {
        units,
        relativeUnits,
        absoluteUnits,
        getDisplayName
    };
});

if (import.meta.hot) {
    import.meta.hot.accept(acceptHMRUpdate(useUnitStore, import.meta.hot));
}
